import { Warning } from '@material-ui/icons';
import { Typography, makeStyles, Theme } from '@material-ui/core';
import { ReactNode } from 'react';

interface PropTypes {
    title: ReactNode;
    subtitle?: ReactNode;
    message?: ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
    error: {
        paddingTop: theme.spacing(4),
        textAlign: 'center',
    },
}));

export const ErrorState = (props: PropTypes): JSX.Element => {
    const { title, subtitle, message } = props;
    const classes = useStyles();

    return (
        <div className={classes.error}>
            <Warning color="error" fontSize="large" />
            <Typography
                gutterBottom
                align="center"
                variant="h6"
            >
                {title}
            </Typography>
            {subtitle && (
                <Typography
                    align="center"
                    variant="body1"
                >
                    {subtitle}
                </Typography>
            )}
            {message && (
                <Typography
                    align="center"
                    variant="body2"
                >
                    {message}
                </Typography>
            )}
        </div>
    );
};
